import { useTranslation } from "react-i18next";
import { ShowFor } from "../ui/ShowFor";
import { SideBarElementDesktop } from "./side-bar-element-desktop";
import { MenuElement } from "./side-bar-nav";
import { Separator } from "../ui/Separator";
import { useMemo } from "react";
import { usePermissions } from "../../hooks/use-permissions";

export function SideBarElementsDesktop({
  menuElements,
}: {
  menuElements: MenuElement[];
}) {
  const { t } = useTranslation();
  const { permissions } = usePermissions();

  const installationMenuElements = useMemo(() => {
    return menuElements.filter((x) => !x.isGlobal);
  }, [menuElements]);

  const globalMenuElements = useMemo(() => {
    return menuElements.filter((x) => x.isGlobal);
  }, [menuElements]);

  const hasVisibleGlobalElements = useMemo(() => {
    return globalMenuElements.some((element) => {
      if (!element.permission) return true;
      return permissions.includes(element.permission);
    });
  }, [globalMenuElements, permissions]);

  return (
    <ul className="list-none align-self-center w-full">
      {installationMenuElements.map((x, i) => (
        <ShowFor key={i} permission={x.permission}>
          <SideBarElementDesktop to={x.to} label={t(x.label)} icon={x.icon} />
        </ShowFor>
      ))}
      {hasVisibleGlobalElements && <Separator />}
      {globalMenuElements.map((x, i) => (
        <ShowFor key={i} permission={x.permission}>
          <SideBarElementDesktop to={x.to} label={t(x.label)} icon={x.icon} />
        </ShowFor>
      ))}
    </ul>
  );
}
